import GetAppIcon from '@material-ui/icons/GetApp'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import CloseIcon from '@mui/icons-material/Close'
import DeleteIcon from '@mui/icons-material/Delete'
import AttachmentIcon from '@mui/icons-material/Attachment'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Popover,
  List,
  ListItem,
  ListItemText,
  Badge,
  Box
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { DatePicker } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import moment from 'moment/moment'
import { useEffect, useRef, useState } from 'react'
import { getRequest } from '../../globalhelper/helper'
import {
  hideLoader,
  showAlert,
  showLoader
} from '../../redux/Common/commonActions'
import store from '../../store'

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
})

function Reconcilation_Upload() {
  const [Companies, setCompanies] = useState([])
  const [Company, setCompany] = useState('')
  const [From, setFrom] = useState('')
  const [To, setTo] = useState('')
  const [Reports, setReports] = useState([])
  const [files, setFiles] = useState({})
  const [selectedRow, setSelectedRow] = useState('')
  const [selectedRowData, setSelectedRowData] = useState({})
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [activeUploadCategory, setActiveUploadCategory] = useState(null)
  const [attachmentPopoverAnchor, setAttachmentPopoverAnchor] = useState(null)
  const [activeAttachmentRow, setActiveAttachmentRow] = useState(null)
  const [uploadCategories, setUploadCategories] = useState([])

  useEffect(() => {
    if (Company) {
      getRequest(
        `api/upload/UploadCredentials?orgid=${Company.orgid}&uploadType=ARUpload`
      ).then(({ res }) => {
        setUploadCategories(JSON.parse(res.data))
      })
    }
  }, [Company])


  const handleOpenPopover = (event, categoryId) => {
    setSelectedRow('')
    setSelectedRowData({})
    setPopoverAnchor(event.currentTarget)
    setActiveUploadCategory(categoryId)
  };

  const handleClosePopover = () => {
    setPopoverAnchor(null)
    setActiveUploadCategory(null)
  };

  const handleOpenAttachmentPopover = (event, row) => {
    setAttachmentPopoverAnchor(event.currentTarget)
    setActiveAttachmentRow(row)
  }

  const handleCloseAttachmentPopover = () => {
    setAttachmentPopoverAnchor(null)
    setActiveAttachmentRow(null)
  }

  const activeCat = uploadCategories.find(c => c.id === activeUploadCategory);

  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(({ res }) => {
        setCompanies(
          (res.data || []).sort((a, b) =>
            (a.orgname || '').localeCompare(b.orgname || '')
          )
        )
      })
      .catch(err => console.log(err))
    var currentDate = moment()
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
    setFrom(firstDay)
    setTo(lastDay)

    getRequest('api/transactions/getReconcilationsReport')
      .then(({ res }) => {
        let Data = JSON.parse(res.data)
        setReports(Data || [])
        console.log(JSON.parse(res.data))
      })
      .catch(err => console.log(err))
  }, [])

  const handleSelectRow = TransId => {
    if (selectedRow !== TransId) {
      setSelectedRowData(Reports.find(item => item.TransactionID === TransId))
      setSelectedRow(TransId)
    } else {
      setSelectedRowData({})
      setSelectedRow('')
    }
  }

  const handleReset = () => {
    setCompany('')
    var currentDate = moment()
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
    setFrom(firstDay)
    setTo(lastDay)
    setFiles({})
  }

  const handleSubmit = () => {
    store.dispatch(showLoader())
    setTimeout(() => {
      store.dispatch(hideLoader())
      store.dispatch(showAlert('File Upload Successfully', 'success'))
      setFiles({})
    }, 5000)
  }

  const downloadResultFile = async () => {
    try {
      let response = await getRequest(`api/upload/getReconRes`)
      if (
        (response?.res?.data.BankReport.type === 'Buffer' ||
          response?.res?.data.CollectionReport.type === 'Buffer') &&
        (Array.isArray(response?.res?.data.CollectionReport.data) ||
          Array.isArray(response?.res?.data.BankReport.data))
      ) {
        const byteArrayBR = new Uint8Array(
          response?.res?.data.CollectionReport.data
        )
        const byteArrayCR = new Uint8Array(response?.res?.data.BankReport.data)
        const contentType =
          response?.res?.headers?.['content-type'] || 'application/octet-stream'
        const fileExtensionMap = {
          'text/csv': '.csv',
          'application/pdf': '.pdf',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            '.xlsx',
          'application/zip': '.zip'
        }

        const extension = fileExtensionMap[contentType] || '.csv'
        const blobBR = new Blob([byteArrayBR], { type: contentType })
        const blobCR = new Blob([byteArrayCR], { type: contentType })

        const urlBR = window.URL.createObjectURL(blobBR)
        const linkBR = document.createElement('a')
        linkBR.href = urlBR
        linkBR.download = `Collection Report${extension}`
        document.body.appendChild(linkBR)
        linkBR.click()

        document.body.removeChild(linkBR)
        window.URL.revokeObjectURL(urlBR)

        const urlCR = window.URL.createObjectURL(blobCR)
        const linkCR = document.createElement('a')
        linkCR.href = urlCR
        linkCR.download = `Bank Report${extension}`
        document.body.appendChild(linkCR)
        linkCR.click()
        document.body.removeChild(linkCR)
        window.URL.revokeObjectURL(urlCR)
      }
    } catch (error) {
      console.log(error)
    }
  }
  console.log(uploadCategories);

  const isReconcileDisabled =
    !Company || !From || !To || Object.keys(files).length === 0;

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
        >
          <Typography variant='h6'>Reconcilation Upload</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2}>
            <Grid item xs={3}>
              <Autocomplete
                size='small'
                fullWidth
                value={Company || null}
                options={Companies}
                getOptionLabel={option => option?.orgname || ''}
                isOptionEqualToValue={(option, value) =>
                  option.orgid === value?.orgid
                }
                onChange={(event, newValue) => setCompany(newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Company'
                    variant='outlined'
                    name='Company'
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='ForPrdFrom'
                  value={From}
                  views={['day', 'month', 'year']}
                  onChange={newValue => {
                    setFrom(newValue.format('YYYY-MM-DD'))
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='ForPrdTo'
                  value={To}
                  views={['day', 'month', 'year']}
                  onChange={newValue => {
                    setTo(newValue.format('YYYY-MM-DD'))
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid>
              <Button
                fullWidth
                variant='outlined'
                color='success'
                onClick={handleSubmit}
                disabled={isReconcileDisabled}
              >
                Reconcile
              </Button>
            </Grid>
            <Grid>
              <Button
                onClick={handleReset}
                fullWidth
                variant='outlined'
                color='error'
              >
                Reset
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={2}>
            {uploadCategories.map(cat => (
              <Grid item xs={12} sm={6} md={4} lg={2} key={cat.id} sx={{ display: 'flex' }}>
                <Badge badgeContent={files[cat.label]?.length || 0} color="secondary" sx={{ width: '100%', '& .MuiBadge-badge': { zIndex: 1 } }}>
                  <Button
                    fullWidth
                    color="primary"
                    variant='contained'
                    startIcon={<CloudUploadIcon />}
                    onClick={(e) => handleOpenPopover(e, cat.id)}
                    sx={{ height: '100%', textTransform: 'none', py: 1, lineHeight: 1.2 }}
                  >
                    {cat.label}
                  </Button>
                </Badge>
              </Grid>
            ))}
          </Grid>

          <Popover
            open={Boolean(popoverAnchor)}
            anchorEl={popoverAnchor}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            {activeCat && (
              <Box sx={{ p: 2, minWidth: 300, maxWidth: 400 }}>
                <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                  {activeCat.label}
                </Typography>

                {files[activeCat.label]?.length > 0 ? (
                  <List dense sx={{ maxHeight: 200, overflow: 'auto', bgcolor: 'background.paper', border: '1px solid #e0e0e0', borderRadius: 1, mb: 2 }}>
                    {files[activeCat.label].map((file, index) => (
                      <ListItem
                        key={index}
                        secondaryAction={
                          <IconButton edge="end" aria-label="delete" size="small" onClick={() => {
                            setFiles(prev => ({ ...prev, [activeCat.label]: prev[activeCat.label].filter((_, i) => i !== index) }));
                          }}>
                            <DeleteIcon fontSize="small" color="error" />
                          </IconButton>
                        }
                      >
                        <ListItemText primary={file.name} secondary={`${(file.size / 1024).toFixed(2)} KB`} primaryTypographyProps={{ noWrap: true }} />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography variant="body2" color="textSecondary" mb={2}>No files selected.</Typography>
                )}

                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button variant="contained" component="label" size="small" fullWidth>
                    Add Files
                    <VisuallyHiddenInput
                      type="file"
                      multiple
                      accept={activeCat.accept}
                      onChange={(e) => {
                        if (e.target.files.length > 0) {
                          const newFiles = Array.from(e.target.files);
                          setFiles(prev => ({ ...prev, [activeCat.label]: newFiles }));
                          e.target.value = null;
                        }
                      }}
                    />
                  </Button>
                  {files[activeCat.label]?.length > 0 && (
                    <Button variant="outlined" color="error" size="small" onClick={() => setFiles({})} fullWidth>
                      Clear All
                    </Button>
                  )}
                </Box>
              </Box>
            )}
          </Popover>
        </AccordionDetails>
      </Accordion >
      {
        Reports.length > 0 && Company && (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size='small' aria-label='a dense table'>
              <TableHead>
                <TableRow>
                  <TableCell>Transaction ID</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>ForPrdFrom</TableCell>
                  <TableCell>ForPrdTo</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Uploaded Attachments</TableCell>
                  <TableCell>Download</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Reports?.map(item => (
                  <TableRow
                    sx={
                      item.TransactionID === selectedRow
                        ? { backgroundColor: 'skyblue' }
                        : ''
                    }
                  >
                    <TableCell>{item.TransactionID}</TableCell>
                    <TableCell>{item.Date}</TableCell>
                    <TableCell>{item.ForPrdFrom}</TableCell>
                    <TableCell>{item.ForPrdTo}</TableCell>
                    <TableCell>{item.Status}</TableCell>
                    <TableCell>
                      <IconButton size="small" color="primary" onClick={(e) => handleOpenAttachmentPopover(e, item)}>
                        <AttachmentIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant='text'
                        color='success'
                        onClick={() => downloadResultFile()}
                      >
                        <GetAppIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )
      }
      <Popover
        open={Boolean(attachmentPopoverAnchor)}
        anchorEl={attachmentPopoverAnchor}
        onClose={handleCloseAttachmentPopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2, minWidth: 250, maxWidth: 400 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              Uploaded Attachments
            </Typography>
            <IconButton size="small" onClick={handleCloseAttachmentPopover}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <List dense sx={{
            maxHeight: 300,
            overflow: 'auto',
            pr: 1,
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#e0e0e0',
              borderRadius: '8px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#9e9e9e',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#757575',
            }
          }}>
            {[
              "BANK STATEMENT",
              "CASH/CHEQUE DEPOSIT",
              "COLLECTION",
              "FILE NAME MAPPING",
              "ONLINE TRANSACTIONS (NEFT/GPAY)",
              "PAYMENT GATEWAY",
              "SALES"
            ].map((key, idx) => {
              if (activeAttachmentRow && activeAttachmentRow[key]) {
                return (
                  <ListItem key={idx} sx={{ py: 0.5, borderBottom: '1px solid #f0f0f0' }}>
                    <ListItemText
                      primary={key}
                      secondary={activeAttachmentRow[key]}
                      primaryTypographyProps={{ variant: 'body2', fontWeight: 'medium' }}
                      secondaryTypographyProps={{ variant: 'caption', sx: { wordBreak: 'break-all' } }}
                    />
                  </ListItem>
                );
              }
              return null;
            })}
            {activeAttachmentRow && ![
              "BANK STATEMENT",
              "CASH/CHEQUE DEPOSIT",
              "COLLECTION",
              "FILE NAME MAPPING",
              "ONLINE TRANSACTIONS (NEFT/GPAY)",
              "PAYMENT GATEWAY",
              "SALES"
            ].some(key => activeAttachmentRow[key]) && (
                <Typography variant="body2" color="textSecondary" sx={{ py: 1 }}>
                  No attachments found.
                </Typography>
              )}
          </List>
        </Box>
      </Popover>
    </>
  )
}

export default Reconcilation_Upload
